"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _GridListTile = _interopRequireDefault(require("@material-ui/core/GridListTile"));

var _MessageEditor = require("../MessageEditor");

var _Image = _interopRequireDefault(require("../Image"));

var _Lightbox = _interopRequireDefault(require("../Lightbox"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _styled = require("./styled");

/**
 * <MediaMosaic /> is a component that render images of a message in a Mosaic tile following
 * certain rules.
 */
var MediaMosaic = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(MediaMosaic, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(MediaMosaic);

  function MediaMosaic() {
    var _this;

    (0, _classCallCheck2["default"])(this, MediaMosaic);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.generateTileData = function (media) {
      var _this$props = _this.props,
          landscapeImages = _this$props.landscapeImages,
          isLandscape = _this$props.isLandscape;
      var isFirstLandscape = isLandscape(media[0]);

      if (media.length === 1) {
        if (isFirstLandscape) {
          return {
            gridListColumns: 1,
            gridTiles: [{
              media: media[0],
              columns: 1
            }],
            cellHeight: 166
          };
        }

        return {
          gridListColumns: 1,
          gridTiles: [{
            media: media[0],
            columns: 1
          }],
          cellHeight: 332
        };
      }

      if (media.length === 2) {
        if (landscapeImages.length === 2) {
          return {
            gridListColumns: 1,
            gridTiles: [{
              media: media[0],
              columns: 1
            }, {
              media: media[1],
              columns: 1
            }],
            cellHeight: 166
          };
        }

        return {
          gridListColumns: 2,
          gridTiles: [{
            media: media[0],
            columns: 1
          }, {
            media: media[1],
            columns: 1
          }],
          cellHeight: 166
        };
      }

      if (media.length === 3) {
        return {
          gridListColumns: isFirstLandscape ? 2 : 3,
          gridTiles: [{
            media: media[0],
            columns: isFirstLandscape ? 2 : 1
          }, {
            media: media[1],
            columns: 1
          }, {
            media: media[2],
            columns: 1
          }],
          cellHeight: 166
        };
      }

      if (media.length === 4) {
        return {
          gridListColumns: isFirstLandscape ? 3 : 2,
          gridTiles: [{
            media: media[0],
            columns: isFirstLandscape ? 3 : 1
          }, {
            media: media[1],
            columns: 1
          }, {
            media: media[2],
            columns: 1
          }, {
            media: media[3],
            columns: 1
          }],
          cellHeight: 166
        };
      }

      return {
        gridListColumns: 6,
        gridTiles: [{
          media: media[0],
          columns: 3
        }, {
          media: media[1],
          columns: 3
        }, {
          media: media[2],
          columns: 2
        }, {
          media: media[3],
          columns: 2
        }, {
          media: media[4],
          columns: 2,
          hasMore: media.length > 5
        }],
        cellHeight: 166
      };
    };

    return _this;
  }

  (0, _createClass2["default"])(MediaMosaic, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          media = _this$props2.media,
          onToggleLightbox = _this$props2.onToggleLightbox,
          lightboxIndex = _this$props2.lightboxIndex,
          isLightboxOpen = _this$props2.isLightboxOpen,
          onCloseLightbox = _this$props2.onCloseLightbox;

      if (!media.length) {
        return null;
      }

      var tileData = this.generateTileData(media);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styled.GridList, {
        cellHeight: tileData.cellHeight,
        cols: tileData.gridListColumns,
        "data-testid": "".concat(id)
      }, tileData.gridTiles.map(function (tile, index) {
        return /*#__PURE__*/_react["default"].createElement(_GridListTile["default"], {
          key: tile.media.uuid,
          cols: tile.columns
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          id: "image-".concat(tile.media.uuid),
          src: tile.media.type === _MessageEditor.MESSAGE_MEDIA_TYPES.IMAGE ? tile.media.src : tile.media.poster,
          onClick: function onClick() {
            return onToggleLightbox(index);
          }
        }, tile.media.type === _MessageEditor.MESSAGE_MEDIA_TYPES.VIDEO && !tile.hasMore && /*#__PURE__*/_react["default"].createElement(_styled.VideoPlayIconWrapper, {
          container: true,
          justify: "center",
          alignItems: "center"
        }, /*#__PURE__*/_react["default"].createElement(_styled.VideoPlayIcon, null)), tile.hasMore && /*#__PURE__*/_react["default"].createElement(_styled.HasMoreWrapper, {
          container: true,
          justify: "center",
          alignItems: "center"
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "h3",
          color: "inherit"
        }, "+".concat(media.length - tileData.gridTiles.length)))));
      })), /*#__PURE__*/_react["default"].createElement(_Lightbox["default"], {
        id: "".concat(id, "-lightbox"),
        key: isLightboxOpen,
        isOpen: isLightboxOpen,
        media: media,
        index: lightboxIndex,
        onClose: onCloseLightbox
      }));
    }
  }]);
  return MediaMosaic;
}(_react["default"].PureComponent);

MediaMosaic.defaultPropTypes = {
  metadata: null
};
var _default = MediaMosaic;
exports["default"] = _default;